export function createCategoryLandingDefaultFormFields(options = {}) {
  const includeMessage = options.includeMessage === true
  const fields = [
    { name: 'customerName', label: '이름', required: true, type: 'text' },
    { name: 'customerPhone', label: '연락처', required: true, type: 'tel' },
    { name: 'preferredContactTime', label: '상담 가능 시간', required: false, type: 'text' },
  ]
  if (includeMessage) {
    fields.push({ name: 'message', label: '문의 내용', required: false, type: 'textarea' })
  }
  return fields
}
